module.exports = __webpack_public_path__ + "img/new-logo.9edc5cc3.png";